import React from 'react';
import { ArcStack } from '@src/core/ui';
import { OrdersWrapperViewProps } from './types';

const OrdersWrapperView: React.FC<OrdersWrapperViewProps> = (props) => {
  const { children, sx, ...rest } = props;
  return (
    <ArcStack 
      py={2}
      gap={1}
      width='100%'
      direction='column'
      sx={{
        height: 'calc(100vh - 140px)',
        maxHeight: 'calc(100vh - 140px)',
        overflowX: 'hidden',
        overflowY: 'auto',
        ...sx,
      }}
      {...rest}>
      {children}
    </ArcStack>
  );
};

export default OrdersWrapperView;